/**
 * Ticker Block JavaScript
 *
 * Provides enhanced functionality for the ticker component:
 * - Calculates animation duration based on content length for consistent speed
 * - Handles window resize events to recalculate animation
 * - Adds motion reduction support
 */

import $ from 'jQuery';

export default function(enableDebug = false) {
	initTickers();

	$(window).on('resize', debounce(initTickers, 250));

	function initTickers() {
		const $tickers = $('.ticker__track');

		if ($tickers.length === 0) {
			if (enableDebug) console.log('No ticker elements found');
			return;
		}

		$tickers.each(function () {
			const $ticker = $(this);
			const $tickerContent = $ticker.find('.ticker__content').first();

			if (!$tickerContent.length) return;

			const contentWidth = $tickerContent.outerWidth();
			const duration = calculateDuration(contentWidth);

			$ticker.css('animation-duration', duration + 's');

			if (enableDebug) console.log('Ticker initialized with duration:', duration + 's');
		});
	}

	function calculateDuration(width) {
		const baseSpeed = 100;
		const minDuration = 10;
		const calculatedDuration = width / baseSpeed;
		return Math.max(calculatedDuration, minDuration);
	}

	function debounce(func, wait) {
		let timeout;
		return function () {
			const context = this;
			const args = arguments;
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				func.apply(context, args);
			}, wait);
		};
	}
}
